var _mask, _path, _path2, _mask2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptySegmentsIcon = function SvgEmptySegmentsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59,
    height: 55,
    fill: "none",
    viewBox: "0 0 59 55"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "EmptySegmentsIcon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M30 3.325c-13.311 0-24.102 10.79-24.102 24.102C5.898 40.738 16.69 51.529 30 51.529s24.102-10.79 24.102-24.102H30.001z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M30 3.325c-13.311 0-24.102 10.79-24.102 24.102C5.898 40.738 16.69 51.529 30 51.529s24.102-10.79 24.102-24.102H30.001z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "M30 3.325h1v-1h-1zm24.102 24.102h1v-1h-1zm-24.101 0h-1v1h1zm0-23.102v-2zM6.897 27.427C6.898 14.667 17.241 4.325 30 4.325v-2c-13.863 0-25.102 11.238-25.102 25.102zM30 50.529c-12.759 0-23.102-10.343-23.102-23.102h-2C4.898 41.29 16.137 52.529 30 52.529zm23.102-23.102c0 12.759-10.343 23.102-23.102 23.102v2c13.864 0 25.102-11.239 25.102-25.102zm0 0h2zm1-1H30.001v2h24.101zm-23.101 1V3.325h-2v24.102z",
    mask: "url(#EmptySegmentsIcon_svg__a)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "EmptySegmentsIcon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M57.428 24.102H33.325V0c13.312 0 24.103 10.79 24.103 24.102",
    clipRule: "evenodd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    fillRule: "evenodd",
    d: "M57.428 24.102H33.325V0c13.312 0 24.103 10.79 24.103 24.102",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    d: "M57.428 24.102v1h1v-1zm-24.103 0h-1v1h1zm0-24.102v-1h-1v1zm24.103 23.102H33.325v2h24.103zm-23.103 1V0h-2v24.102zM33.325 1v-2zm0 0c12.76 0 23.103 10.343 23.103 23.102h2C58.428 10.24 47.188-1 33.325-1zm23.103 23.102h2z",
    mask: "url(#EmptySegmentsIcon_svg__b)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#fff",
    transform: "matrix(-1 0 0 1 25.742 26.533)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#3D4355",
    d: "M13.054 48.772c-5.483 0-9.927-4.445-9.927-9.927 0-5.483 4.444-9.927 9.927-9.927s9.926 4.444 9.926 9.927-4.444 9.927-9.926 9.927Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3D4355",
    strokeLinecap: "round",
    d: "M13.205 44.58V34.005M18.494 39.292H7.917"
  })));
};
export default SvgEmptySegmentsIcon;